"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownChevronMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @mixin dropdownChevronMixin */
/**
 * Adds a down chevron as a background image.
 *
 * @example
 * import { dropdownChevronMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${dropdownChevronMixin}
 * `;
 *
 * <Component>My component with a dropdown chevron </Component>
 *
 * @method
 * @param {object} props
 * @param {object} props.theme - The styled-components theme object.
 * @return {CSSObject}
 */
var dropdownChevronMixin = function dropdownChevronMixin(props) {
  return (0, _styledToken.default)({
    color: 'Select.chevronColor',
    height: 'Select.chevronHeight',
    width: 'Select.chevronWidth'
  }, function (_ref) {
    var color = _ref.color,
      height = _ref.height,
      width = _ref.width;
    var expandedTransform = props['aria-expanded'] === 'true' ? ' transform="scale(1, -1)"' : '';

    // Need to encode the full SVG object for IE11
    // https://stackoverflow.com/questions/37550476/inline-svg-background-not-working-in-internet-explorer-11
    var chevron = encodeURIComponent("\n<svg width=\"" + width + "px\" height=\"" + height + "px\" xmlns=\"http://www.w3.org/2000/svg\"" + expandedTransform + ">\n    <path fill=\"none\" stroke-linecap=\"round\" stroke=\"" + color + "\" stroke-width=\"2\" d=\"M28.657 12L23 17.657 17.343 12\" transform=\"translate(-7, 0)\" />\n</svg>").replace(/\(/g, '%28').replace(/\)/g, '%29');
    return "\n            background-image: url('data:image/svg+xml," + chevron + "');\n            background-repeat: no-repeat;\n\n            &:focus, /* needed for zsg */\n            &:hover, /* needed for zsg */\n            &:disabled, /* needed for zsg */\n            & {\n                background-position: right center;\n            }\n        ";
  })(props);
};
exports.dropdownChevronMixin = dropdownChevronMixin;